module.exports = __webpack_public_path__ + "portal-static/img/user_administrator.6c885805.png";